import { registerPlugin } from '@capacitor/core';
const Fingerprint = registerPlugin('Fingerprint', {
    web: () => import('./web').then((m) => new m.FingerprintWeb()),
});
export * from './definitions';
export { Fingerprint };
//# sourceMappingURL=index.js.map